<template>
  <div>
    <img style="width: 100%;" src="../assets/home-banner.png">
    <el-row type="flex" justify="center">
      <el-col :span="24" style="width: 1280px">
        <el-row>
          <img style="width: 100%;" src="../assets/home-content-0.png">
        </el-row>
        <el-row>
          <img style="width: 100%;" src="../assets/home-content-1.png">
        </el-row>
        <el-row>
          <img style="width: 100%;" src="../assets/home-content-2.png">
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
